// 22.01.19 - This is used by the Saga for the view cases.
import axios from "axios";
import {
  APP_NAME,
  AUTH_TOKEN,
  GET_CASE_ALL,
  GET_CASES_BY_USER,
  EXPORT_COMPLAINT,
  EXPORT_CLAIM,
  EXPORT_INCIDENT_REPORT
} from "../../constants/api";
import { GET_SP_USER_DATA_VIA_GRAPH } from "../../constants/api";

export interface IServerResponse<T> {
  message: string;
  success: boolean;
  count?: number;
  data?: T;
}

axios.interceptors.request.use(
  (config) => {
    config.headers.AppName = APP_NAME;
    config.headers.AuthenticationToken = AUTH_TOKEN;
    return config;
  },
  (err) => {
    return err;
  }
);

export const getAllCasesUtility = async () => {
  // axios.get is the function that performs the actual request and receives the data
  try {
    const response = await axios.get(GET_CASE_ALL);
    return response.data;
  } catch (e) {
    return {
      message: e.toString(),
      success: false,
    };
  }
};
export const getAllCasesByUserUtility = async (
  paths: string[]
): Promise<any> => {
  // axios.get is the function that performs the actual request and receives the data
  try {
    const response = await axios.get(GET_CASES_BY_USER + paths.join("/"));
    return response.data;
  } catch (e) {
    return {
      message: e.toString(),
      success: false,
    };
  }
};


/**
 * API for exporting all the Claim data into excel
 */
export const apiExportClaim = () => {
  return axios.get(EXPORT_CLAIM, { responseType: "blob" }).then(
    (resp: any) => {
      return resp;
    },
    (err: any) => {
      return err;
    }
  );
};


/**
 * API for exporting all the Complaint data into excel
 */
export const apiExportComplaint = () => {
  return axios.get(EXPORT_COMPLAINT, { responseType: "blob" }).then(
    (resp: any) => {
      return resp;
    },
    (err: any) => {
      return err;
    }
  );
};

export const apiExportIncidentReport = () => {
  return axios.get(EXPORT_INCIDENT_REPORT, { responseType: "blob" }).then(
    (resp: any) => {
      return resp;
    },
    (err: any) => {
      return err;
    }
  );
};

/**
 * Function for getting the logged in user's identity details
 */
export const apiGetSPUserViaGraph = async (data: any) => {
    const url = `${GET_SP_USER_DATA_VIA_GRAPH}${data}`;
    const response = await axios.get(url);
    return await response;
};